import { supabase } from '@/core/database/supabase';
import { enforceSettingsPermission } from '@/modules/settings/permissions/enforceSettingsPermission';
import type { AccountRecord } from '../../list/types/accounts.types';

export const accountsNewService = {
  async createAccount(data: Partial<AccountRecord>) {
    await enforceSettingsPermission('settings.account.create');
    
    const { data: result, error } = await supabase
      .from('settings_accounts')
      .insert({
        company_id: data.companyId,
        account_name: data.accountName,
        account_number: data.accountNumber,
        bank_name: data.bankName,
        bank_branch: data.bankBranch,
        account_holder: data.accountHolder,
        currency: data.currency || 'VND',
        initial_balance: data.initialBalance || 0,
        current_balance: data.initialBalance || 0,
        status: data.status || 'active',
        is_default: data.isDefault || false,
        description: data.description,
        created_by: data.createdBy,
      })
      .select()
      .single();

    if (error) throw error;
    return result;
  }
};
